import { render, staticRenderFns } from "./RaceVideoPane.vue?vue&type=template&id=0ef37ec4&scoped=true"
import script from "./RaceVideoPane.vue?vue&type=script&lang=ts"
export * from "./RaceVideoPane.vue?vue&type=script&lang=ts"
import style0 from "./RaceVideoPane.vue?vue&type=style&index=0&id=0ef37ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef37ec4",
  null
  
)

export default component.exports